import { queryExecutor } from '@/_core/cqrs';
import { Action } from '@/_core/fluxstore/types';
import { BoardActivityPanelState } from '../types';
import { useBoardActivityStore } from '../useModule';
import { useStorymapStore } from '../../../store';
import { BoardActivityUnseenCountQuery } from '../../api/queries';
import type { BoardActivityUnseenCountResult } from '../../api/queries';

const { registerMiddleware, registerReducer } = useBoardActivityStore();

export class LoadUnseenBoardActivityCount extends Action<BoardActivityPanelState> {
    public static ACTION_TYPE = 'BoardActivity::LoadUnseenCount';
    public _res: BoardActivityUnseenCountResult | null = null;

    constructor() {
        super(LoadUnseenBoardActivityCount.ACTION_TYPE);
    }
}

const middleware = async (_state: BoardActivityPanelState, action: LoadUnseenBoardActivityCount): Promise<boolean> => {
    const storymapStore = useStorymapStore();
    const storymapId = storymapStore.state.id;
    if (!storymapId) {
        return false;
    }

    const result = await queryExecutor.executeQuery<BoardActivityUnseenCountResult>(
        new BoardActivityUnseenCountQuery(storymapId)
    );
    action._res = result;
    return true;
};

const reducer = (state: BoardActivityPanelState, action: LoadUnseenBoardActivityCount): void => {
    if (!action._res) {
        return;
    }

    state.unseenCount = Math.max(state.unseenCount, action._res.UnseenCount);
    state.latestRelevantActivityId = action._res.LatestRelevantActivityId || state.latestRelevantActivityId;
};

//@ts-ignore
registerMiddleware(LoadUnseenBoardActivityCount.ACTION_TYPE, middleware);
//@ts-ignore
registerReducer(LoadUnseenBoardActivityCount.ACTION_TYPE, reducer);
